module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thick_extra_heart_mask.53ca31a2.png";